import React from 'react';
import { oneOfType, func, object, string } from 'prop-types';
import './style.less';

function LanguageFlag({ icon: IconComponent, className, style }) {
  if (!IconComponent) return null;

  return (
    <span
      className={['language-flag', className].filter(Boolean).join(' ')}
      style={style}
      aria-hidden="true"
    >
      <IconComponent focusable="false" />
    </span>
  );
}

LanguageFlag.propTypes = {
  icon: oneOfType([func, object]),
  className: string,
  style: object,
};

LanguageFlag.defaultProps = {
  icon: undefined,
  className: undefined,
  style: undefined,
};

export default LanguageFlag;
